import React, { useEffect, useState } from "react";
import MockResultPageLayout from "./MockResultPageLayout";

export default function SpeakingMockResultPage() {
  const [mockTests, setMockTests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const fetchMockTestData = async () => {
      try {
        const response = await fetch("/api/fetch-speakingmocktestdata", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.status === 404 || response.status === 204) {
          setMockTests([]);
          return;
        }

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        setMockTests(Array.isArray(data) ? data : []);
      } catch (err) {
        setError("Error fetching mock test data");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchMockTestData();
  }, []);

  const itemsPerPage = 10;
  const totalPages = Math.ceil(mockTests.length / itemsPerPage);
  const maxPagesToShow = 7;
  const halfMaxPages = Math.floor(maxPagesToShow / 2);

  const getPageNumbers = () => {
    const pageNumbers = [];

    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
    } else if (currentPage <= halfMaxPages) {
      for (let i = 1; i <= maxPagesToShow; i++) pageNumbers.push(i);
    } else if (currentPage > totalPages - halfMaxPages) {
      for (let i = totalPages - maxPagesToShow + 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      for (let i = currentPage - halfMaxPages; i <= currentPage + halfMaxPages; i++) {
        pageNumbers.push(i);
      }
    }

    return pageNumbers;
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, mockTests.length);

  return (
    <MockResultPageLayout
      activeSection="Speaking"
      error={error}
      isLoading={loading}
      items={mockTests}
      pageNumbers={getPageNumbers()}
      currentPage={currentPage}
      totalPages={totalPages}
      startIndex={startIndex}
      endIndex={endIndex}
      onPageChange={setCurrentPage}
    />
  );
}
